import { NgModule } from '@angular/core';


@NgModule({
    entryComponents: [

    ],
    declarations: [
    ],
    exports: [
    ],
    providers: []
})
export class SharedModule { }
